import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FarmService} from '@services/farm.service';
import {SupplierService} from '@services/supplier.service';
import {LoaderService} from '@services/loader.service';
import {ToastrService} from 'ngx-toastr';
import {Observable, forkJoin, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-farm-detail',
    templateUrl: './farm-detail.component.html',
    styleUrls: ['./farm-detail.component.scss']
})
export class FarmDetailComponent implements OnInit, OnDestroy {
    farm: any = null;
    availableSensors: any[] = [];
    birdTypes: any[] = [];
    // BREED - COMMENTED OUT
    // breeds: any[] = [];
    isLoading$!: Observable<boolean>;

    private destroy$ = new Subject<void>();

    constructor(
        private farmService: FarmService,
        private route: ActivatedRoute,
        private supplierService: SupplierService,
        private toastr: ToastrService,
        private router: Router,
        private loaderService: LoaderService
    ) {
        this.isLoading$ = this.loaderService.isLoading$;
    }

    ngOnInit(): void {
        const farmId = +this.route.snapshot.params['id'];

        this.loaderService.showLoader();

        forkJoin({
            farm: this.farmService.getFarmDetail(farmId),
            // SENSORS - HIDE UI
            // sensors: this.farmService.getSensorsList(),
            birdTypes: this.supplierService.getBirdTypeList()
            // BREED - COMMENTED OUT
            // breeds: this.supplierService.getBreedList()
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: ({farm, birdTypes}) => {
                    this.farm = farm;
                    // SENSORS - HIDE UI
                    // this.availableSensors = sensors;
                    this.birdTypes = birdTypes;
                    // BREED - COMMENTED OUT
                    // this.breeds = breeds;
                    this.loaderService.hideLoader();
                },
                error: () => {
                    this.toastr.error('Failed to load farm details');
                    this.loaderService.hideLoader();
                }
            });
    }

    getBirdTypeName(typeId: number): string {
        const birdType = this.birdTypes.find((bt) => bt.id === typeId);
        return birdType?.name || 'Unknown';
    }

    // BREED - COMMENTED OUT
    // getBreedName(breedId: number): string {
    //     const breed = this.breeds.find((b) => b.id === breedId);
    //     return breed?.name || 'Unknown';
    // }

    getSensorNames(sensors: any[]): string {
        if (!sensors || sensors.length === 0) return 'No sensors assigned';

        const sensorNames = sensors
            .map((sensor) => {
                // If sensor is an object with id, find the name from availableSensors
                if (typeof sensor === 'object' && sensor.id) {
                    const foundSensor = this.availableSensors.find(
                        (s) => s.id === sensor.id
                    );
                    return (
                        foundSensor?.name ||
                        sensor.name ||
                        `Sensor ${sensor.id}`
                    );
                }
                // If sensor is just an id
                else if (typeof sensor === 'number') {
                    const foundSensor = this.availableSensors.find(
                        (s) => s.id === sensor
                    );
                    return foundSensor?.name || `Sensor ${sensor}`;
                }
                return 'Unknown Sensor';
            })
            .join(', ');

        return sensorNames;
    }

    goBack(): void {
        this.router.navigate(['/farms-information']);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
